// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"27":"5d214992","138":"de722a01","195":"9d39b344","212":"542c5e5a","220":"2f742339","456":"b1130dd7","481":"b332b43b","662":"e518303c","757":"f2ea3cbb","808":"cf59dde0","829":"5af5b23b","848":"f9d04b28","871":"0e3f564b"}[chunkId] + ".js";
};